import { PhoneOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { Text, Title } from './styles';

const DadosMotorista = ({ dataMotorista }) => (
  <Row>
    <Col span={24} className="mb-20">
      <Title level={4}>Nome</Title>
      <Text level={4}>{dataMotorista.nome}</Text>
    </Col>

    <Col span={12}>
      <Title level={4}>
        Telefone&nbsp;
        <PhoneOutlined />
      </Title>
      <Text>{dataMotorista.telefone}</Text>
    </Col>

    <Col span={12}>
      <Title level={4}>
        Celular&nbsp;
        <WhatsAppOutlined />
      </Title>
      <Text>{dataMotorista.celular}</Text>
    </Col>
  </Row>
);

DadosMotorista.propTypes = {
  dataMotorista: PropTypes.shape({
    nome: PropTypes.string,
    telefone: PropTypes.string,
    celular: PropTypes.string,
  }),
};

DadosMotorista.defaultProps = {
  dataMotorista: {},
};
export default DadosMotorista;
